var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6667 68.4166C65.6667 69.6592 64.6594 70.6666 63.4167 70.6666H58.9167C57.6741 70.6666 56.6667 69.6592 56.6667 68.4166V36.9166C56.6667 35.674 57.6741 34.6666 58.9167 34.6666H63.4167C64.6594 34.6666 65.6667 35.674 65.6667 36.9166V68.4166ZM47.6667 68.4166C47.6667 69.6592 46.6594 70.6666 45.4167 70.6666H40.9167C39.6741 70.6666 38.6667 69.6592 38.6667 68.4166V36.9166C38.6667 35.674 39.6741 34.6666 40.9167 34.6666H45.4167C46.6594 34.6666 47.6667 35.674 47.6667 36.9166V68.4166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.dd79915e5aa8723088a8164183743cb8.svg";
export { ForwardRef as ReactComponent };